// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as V2$Linear from "./V2.res.js";

function mapToString(v) {
  return V2$Linear.map(v, x => x.toString());
}

let zero = V2$Linear.fill(0);

function plus(param, param$1) {
  return [
    param[0] + param$1[0],
    param[1] + param$1[1]
  ];
}

function minus(param, param$1) {
  return [
    param[0] - param$1[0],
    param[1] - param$1[1]
  ];
}

function multiply(param, param$1) {
  return [
    param[0] * param$1[0],
    param[1] * param$1[1]
  ];
}

function divide(param, param$1) {
  return [
    param[0] / param$1[0],
    param[1] / param$1[1]
  ];
}

function recip(param) {
  return [
    1 / param[0],
    1 / param[1]
  ];
}

function scale(vec, factor) {
  return V2$Linear.map(vec, v => v * factor);
}

function dot(param, param$1) {
  return param[0] * param$1[0] + param[1] * param$1[1];
}

function quadrance(vec) {
  return dot(vec, vec);
}

function length(vec) {
  return Math.sqrt(dot(vec, vec));
}

function diff(x, y) {
  let vec = minus(x, y);
  return Math.sqrt(dot(vec, vec));
}

function scaleTo(vec, len) {
  let l = Math.sqrt(dot(vec, vec));
  if (l !== 0) {
    return scale(vec, len / l);
  } else {
    return zero;
  }
}

function normal(a) {
  return scaleTo(a, 1);
}

function projectOn(point, on) {
  let on$p = scaleTo(on, 1);
  return scale(on$p, dot(point, on$p));
}

function rotate(param, a) {
  let y = param[1];
  let x = param[0];
  return [
    x * Math.cos(a) - y * Math.sin(a),
    x * Math.sin(a) + y * Math.cos(a)
  ];
}

function perpendicularCW(param) {
  return [
    param[1],
    - param[0]
  ];
}

function perpendicularCCW(param) {
  return [
    - param[1],
    param[0]
  ];
}

function angle(a, b) {
  let l = Math.sqrt(dot(a, a)) * Math.sqrt(dot(b, b));
  if (l !== 0) {
    return Math.acos(dot(a, b) / l);
  } else {
    return 0;
  }
}

function dirAngle(param, param$1) {
  return Math.atan2(param[1], param[0]) - Math.atan2(param$1[1], param$1[0]);
}

function asV3f(param, f) {
  let match = f([
    param[0],
    param[1],
    1
  ]);
  return [
    match[0],
    match[1]
  ];
}

function crossZ(param, param$1) {
  return param[0] * param$1[1] - param[1] * param$1[0];
}

let jsonCodec = V2$Linear.jsonCodec(Jzon.float);

export {
  mapToString,
  zero,
  plus,
  minus,
  multiply,
  divide,
  recip,
  scale,
  dot,
  quadrance,
  length,
  diff,
  scaleTo,
  normal,
  projectOn,
  rotate,
  perpendicularCW,
  perpendicularCCW,
  angle,
  dirAngle,
  asV3f,
  crossZ,
  jsonCodec,
}
/* zero Not a pure module */
